<mat-toolbar class="footer" >
  <span>
        RADIODOC 2021 
        <!-- <i class="material-icons">favorite</i> -->
  </span>
</mat-toolbar>